import {booleanAttribute, Component, ContentChild, inject, Input, TemplateRef} from '@angular/core';
import {CustomLoaderService} from "../../services/custom-loader.service";
import {CommonModule} from "@angular/common";
import {NgxUiLoaderModule} from "ngx-ui-loader";
import {TranslateModule} from "@ngx-translate/core";
import {CardFooterDirective} from "./directives/card-footer.directive";
import {CardToolbarDirective} from "./directives/card-toolbar.directive";

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    CommonModule,
    NgxUiLoaderModule,
    TranslateModule
  ],
  template: `
    <div
      *ngIf="undefined !== mainHeader"
      class="d-flex w-100 justify-content-start align-items-center pb-2">
      <label class="" [ngClass]="mainHeaderClass" [innerHTML]="mainHeader || '' | translate"></label>
    </div>

    <div
      class="card gutter-b"
      [class.card-flush]="!showDivider"
      [class.bg-transparent]="bgTransparent">

      <ngx-ui-loader [loaderId]="componentLoaderID"></ngx-ui-loader>

      <div *ngIf="showCardHeader" class="card-header flex-wrap pt-2 pb-0">
        <div class="card-title" [ngClass]="cardTitleClass">
          <h2 class="card-title align-items-start flex-column fw-bolder">
              <span class="card-label fw-bolder fs-3 pb-1">
                {{ cardTitle || '' | translate }}
             </span>
            <span *ngIf="undefined !== cardSubtitle" class="text-muted fw-bold fs-7">
                 {{ cardSubtitle || '' | translate }}
              </span>
          </h2>
        </div>
        <div class="card-toolbar" *ngIf="toolbarTemplateRef">
            <ng-container *ngTemplateOutlet="toolbarTemplateRef"></ng-container>
        </div>
      </div>
      <div class="card-body" [ngClass]="cardBodyClass">
        <ng-content></ng-content>
      </div>
      <div class="card-footer" *ngIf="footerTemplateRef">
          <ng-container *ngTemplateOutlet="footerTemplateRef"></ng-container>
      </div>
    </div>
  `,
  styleUrls: []
})
/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export class CardComponent {

  private customLoaderService: CustomLoaderService = inject(CustomLoaderService);

  @Input() cardTitle: string | null = 'Card Title';
  @Input() cardSubtitle?: string;
  @Input() cardTitleClass: string | string[] = '';
  @Input() cardBodyClass: string | string[] = '';
  @Input({transform: booleanAttribute}) showDivider: boolean = false;
  @Input({transform: booleanAttribute}) bgTransparent: boolean = false;
  @Input({transform: booleanAttribute}) showCardHeader: boolean = true;
  @Input() mainHeader?: string;
  @Input() mainHeaderClass: string | string[] = '';


  private _blocked?: boolean | null  = false;
  @Input({transform: booleanAttribute})
  get blocked() {
    return this._blocked;
  };
  set blocked(value) {
    this.toggleLoading(value)
    this._blocked = value ?? false;
  };

  componentLoaderID: string = 'kt-card-loaderId-' + self.crypto.randomUUID();

  @ContentChild(CardFooterDirective, {read: TemplateRef})
  footerTemplateRef?: TemplateRef<any>;

  @ContentChild(CardToolbarDirective, {read: TemplateRef})
  toolbarTemplateRef?: TemplateRef<any>;

  private toggleLoading(sate: boolean | undefined | null) {
    if (true === sate) {
      this.customLoaderService.startLoader(this.componentLoaderID)
      return;
    }

    this.customLoaderService.stopLoader(this.componentLoaderID)
  }

}
